export default "__VITE_ASSET__WpRbp4Mh__"